import { defineComponent as _defineComponent } from 'vue'
import baseUrl from "@/constants";
import {reactive} from "vue";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  setup(__props) {

const form = reactive({
  docType: "YYZZ"
})
const download = () => {
  window.open(baseUrl + `/file/download-empower?legal=&orgName=&agent=&idCard=`, '_blank');
}

const goRegisterCompany = () => {
  router.replace('/change-mechanism-index?docType=' + form.docType);
}

return { __sfc: true,form, download, goRegisterCompany }
}

})